import CancelIcon from "@mui/icons-material/Cancel";
import SamaraFullDarkLogo from "assets/images/SamaraFullDarkLogo.svg";
import UICard from "components/ui/card/UICard";
import UIButton from "components/ui/form/UIButton";
import { useNavigate } from "react-router-dom";

const ErrorFallback = (props) => {
  const navigate = useNavigate();
  const { error, resetErrorBoundary } = props;

  const retryChecking = () => {
    resetErrorBoundary();
  };

  const navigateToDashboard = () => {
    navigate(process.env.REACT_APP_ENTRY_POINT_AFTER_LOGIN);
    window.location.reload();
  };

  return (
    <>
      <div className="centered-justified-no-page">
        <div className="d-flex align-items-center">
          <img
            style={{ width: "15rem" }}
            src={SamaraFullDarkLogo}
            alt="Samaras Logo"
          />
        </div>
        <div className="my-3">
          <UICard
            customClasses="b1-primary shadow-lg p-5 m-md-5"
            jsx
            CardBody={
              <>
                <p className="text-center mb-3">
                  <CancelIcon style={{ fontSize: 60 }} color="error" />
                </p>
                <p className="fs text-center">
                  Something went wrong while handling your request, please retry
                  or
                  <br />
                  navigate to home.
                </p>
                <small className="fxs text-center">
                  <p>What went wrong?</p>
                  <p className="text-danger">{error?.message || ""}</p>
                </small>
              </>
            }
          />
        </div>
        <div className="d-inline gx-2">
          <UIButton callback={retryChecking} text="Retry" />
          &emsp;
          <UIButton callback={navigateToDashboard} text="Dashboard" />
        </div>
      </div>
    </>
  );
};

export default ErrorFallback;
